var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPrivacyPopUpLogo = function SvgPrivacyPopUpLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64.348,
    height: 77.68,
    viewBox: "0 0 64.348 77.68",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_hands_430101",
    transform: "translate(-16.81 -5.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16716",
    "data-name": "Group 16716",
    transform: "translate(16.81 48.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16700",
    "data-name": "Group 16700",
    transform: "translate(5.68 1.336)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10059",
    "data-name": "Path 10059",
    d: "M39.989,74.453l-.175-.174C39.7,74.162,28.033,62.517,22.7,59.7a.4.4,0,0,1,.375-.707c5.142,2.719,15.6,13.035,17.131,14.551a26.268,26.268,0,0,1,4.518-.857.4.4,0,0,1,.086.795,24.523,24.523,0,0,0-4.589.895Z",
    transform: "translate(-22.49 -58.946)",
    fill: "#07a3c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16701",
    "data-name": "Group 16701",
    transform: "translate(26.705 15.066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10060",
    "data-name": "Path 10060",
    d: "M44.769,73.482a.4.4,0,0,1-.047-.8l.048.4-.036-.4.054-.008a.4.4,0,0,1,.081.8l-.05.006A.444.444,0,0,1,44.769,73.482Z",
    transform: "translate(-44.369 -72.676)",
    fill: "#07a3c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16702",
    "data-name": "Group 16702",
    transform: "translate(0 0.633)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10061",
    "data-name": "Path 10061",
    d: "M45.234,83.625c-4.343,0-7.947-.236-9.295-.922-2.168-1.1-18.555-18.166-18.967-19.115a5,5,0,0,1,.821-4.195,3.5,3.5,0,0,1,3.743-1.016,6.287,6.287,0,0,1,1.54.615.4.4,0,1,1-.373.707,5.63,5.63,0,0,0-1.338-.541,2.777,2.777,0,0,0-2.954.742,4.4,4.4,0,0,0-.715,3.348C18.428,64.3,34.1,80.869,36.3,81.99c4.076,2.074,31.766-.328,32.043-.352a.4.4,0,0,1,.434.363.4.4,0,0,1-.363.434C67.629,82.5,54.684,83.625,45.234,83.625Z",
    transform: "translate(-16.81 -58.243)",
    fill: "#07a3c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16703",
    "data-name": "Group 16703",
    transform: "translate(18.062 6.762)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10062",
    "data-name": "Path 10062",
    d: "M43.31,71.893a.4.4,0,0,1-.274-.109c-1.505-1.424-5.407-5-7.374-6.711a.4.4,0,0,1,.525-.6c1.974,1.721,5.889,5.305,7.4,6.732a.4.4,0,0,1-.275.691Z",
    transform: "translate(-35.525 -64.371)",
    fill: "#07a3c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16704",
    "data-name": "Group 16704",
    transform: "translate(11.544 1.452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10063",
    "data-name": "Path 10063",
    d: "M35.924,65.17a.405.405,0,0,1-.263-.1A63.5,63.5,0,0,0,28.95,59.8a.4.4,0,0,1,.434-.672,64.585,64.585,0,0,1,6.8,5.344.4.4,0,0,1-.263.7Z",
    transform: "translate(-28.767 -59.061)",
    fill: "#07a3c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16705",
    "data-name": "Group 16705",
    transform: "translate(5.679)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10064",
    "data-name": "Path 10064",
    d: "M29.167,59.861a.4.4,0,0,1-.217-.064,8.974,8.974,0,0,0-2.563-1.27,2.7,2.7,0,0,0-3.159,1.031.4.4,0,0,1-.678-.424c.568-.91,1.727-1.889,4.008-1.389a9.449,9.449,0,0,1,2.825,1.379.4.4,0,0,1,.119.553A.393.393,0,0,1,29.167,59.861Z",
    transform: "translate(-22.489 -57.61)",
    fill: "#07a3c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16706",
    "data-name": "Group 16706",
    transform: "translate(25.856 9.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10065",
    "data-name": "Path 10065",
    d: "M43.489,68.119l.518-.609-.168.2.186-.186-.274.291Z",
    transform: "translate(-43.489 -67.51)",
    fill: "#07a3c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16707",
    "data-name": "Group 16707",
    transform: "translate(19.481 4.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10066",
    "data-name": "Path 10066",
    d: "M43.742,68.211a.4.4,0,0,1-.268-.1c-1.148-1.033-5.191-4.549-6.344-5.492a.4.4,0,0,1,.506-.62c1.187.973,5.188,4.451,6.372,5.518a.4.4,0,0,1,.03.564A.392.392,0,0,1,43.742,68.211Z",
    transform: "translate(-36.983 -61.906)",
    fill: "#07a3c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16708",
    "data-name": "Group 16708",
    transform: "translate(11.533 0.632)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10067",
    "data-name": "Path 10067",
    d: "M37.383,62.707a.4.4,0,0,1-.253-.092c-3.189-2.609-4.667-3.334-5.345-3.482a2.168,2.168,0,0,0-2.308.58.4.4,0,0,1-.622-.5,2.888,2.888,0,0,1,3.1-.857c1.125.246,2.983,1.439,5.68,3.645a.4.4,0,0,1-.252.71Z",
    transform: "translate(-28.766 -58.242)",
    fill: "#07a3c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16709",
    "data-name": "Group 16709",
    transform: "translate(26.908 8.695)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10068",
    "data-name": "Path 10068",
    d: "M44.978,67.107a.391.391,0,0,1-.279-.117l0,0a.395.395,0,1,1,.283.121Z",
    transform: "translate(-44.578 -66.305)",
    fill: "#07a3c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16710",
    "data-name": "Group 16710",
    transform: "translate(19.467 4.051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10069",
    "data-name": "Path 10069",
    d: "M44.978,67.1a.4.4,0,0,1-.288-.121c-.038-.039-3.748-3.875-5.491-4.412a2.209,2.209,0,0,0-1.647.1.4.4,0,1,1-.335-.726,3.024,3.024,0,0,1,2.219-.137c1.938.6,5.673,4.455,5.83,4.619a.4.4,0,0,1-.01.566A.409.409,0,0,1,44.978,67.1Z",
    transform: "translate(-36.984 -61.66)",
    fill: "#07a3c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16711",
    "data-name": "Group 16711",
    transform: "translate(26.452 15.074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10070",
    "data-name": "Path 10070",
    d: "M54.461,74.359a62.669,62.669,0,0,1-9.032-.691,2.128,2.128,0,0,1-.836-.227.4.4,0,1,1,.351-.717,1.326,1.326,0,0,0,.536.145l.044,0c8.725,1.279,13.934.391,14.153.354a.4.4,0,1,1,.139.787A33.649,33.649,0,0,1,54.461,74.359Z",
    transform: "translate(-44.369 -72.683)",
    fill: "#07a3c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16712",
    "data-name": "Group 16712",
    transform: "translate(25.017 9.799)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10071",
    "data-name": "Path 10071",
    d: "M44.769,73.482a.382.382,0,0,1-.176-.041,3.735,3.735,0,0,1-1.808-2.426,4.105,4.105,0,0,1,.622-3.428l.031-.037a.4.4,0,1,1,.606.519l-.3-.26.3.26a3.306,3.306,0,0,0-.485,2.746,2.969,2.969,0,0,0,1.385,1.908.4.4,0,0,1-.175.759Z",
    transform: "translate(-42.649 -67.409)",
    fill: "#07a3c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16713",
    "data-name": "Group 16713",
    transform: "translate(25.695 8.699)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10072",
    "data-name": "Path 10072",
    d: "M43.742,68.211a.385.385,0,0,1-.237-.08.4.4,0,0,1-.085-.559,4.941,4.941,0,0,1,1.328-1.2.4.4,0,0,1,.432.674,4.135,4.135,0,0,0-1.116,1A.4.4,0,0,1,43.742,68.211Z",
    transform: "translate(-43.342 -66.308)",
    fill: "#07a3c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16714",
    "data-name": "Group 16714",
    transform: "translate(26.9 8.712)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10073",
    "data-name": "Path 10073",
    d: "M44.969,67.105a.4.4,0,0,1-.388-.291.4.4,0,0,1,.273-.492l.123.381.09.391-.09-.391.1.389A.373.373,0,0,1,44.969,67.105Z",
    transform: "translate(-44.566 -66.322)",
    fill: "#07a3c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16715",
    "data-name": "Group 16715",
    transform: "translate(25.736 6.485)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10074",
    "data-name": "Path 10074",
    d: "M62.707,92.316l.088-.475a17.681,17.681,0,0,0-.492-9.209.4.4,0,0,1,.736-.31,17.849,17.849,0,0,1,.623,9.191l18.66-.043C81,75.222,78.99,70.976,78.97,70.935l-.027-.07c-.068-.242-1.8-5.969-9.881-5.969-15.678,0-23.649,2.1-23.981,2.193a.4.4,0,1,1-.208-.771c.336-.092,8.406-2.223,24.189-2.223,8.352,0,10.467,5.973,10.641,6.514.205.439,2.152,4.951,3.453,21.229l.033.432Z",
    transform: "translate(-44.577 -64.095)",
    fill: "#07a3c8"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10075",
    "data-name": "Path 10075",
    d: "M60.77,34.516c-1.432-.44-4.2-3.12-5.156-4.076a4.866,4.866,0,0,0,.656-.588c1.252,1.112,4.041,3.536,5.488,4.756A2.285,2.285,0,0,1,60.77,34.516Z",
    transform: "translate(-1.309 -1.464)",
    fill: "#07a3c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10076",
    "data-name": "Path 10076",
    d: "M56.75,29.2a4.067,4.067,0,0,0,.551-2.46c1.824,1.692,4.828,4.437,6.48,5.876a69.175,69.175,0,0,0,6.385,5.064,2.365,2.365,0,0,1-1.98.268c-.676-.147-2.141-.864-5.3-3.439a.112.112,0,0,0-.043-.036c0-.008-.008-.012-.012-.008a.081.081,0,0,0-.033-.028C61.678,33.512,58.139,30.44,56.75,29.2Z",
    transform: "translate(-1.532 -1.387)",
    fill: "#07a3c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10077",
    "data-name": "Path 10077",
    d: "M76.49,37.868a2.8,2.8,0,0,1-2.908.692,8.916,8.916,0,0,1-2.564-1.272,63.868,63.868,0,0,1-6.707-5.271c-1.973-1.716-5.873-5.288-7.377-6.712a.408.408,0,0,0-.043-.036,3.957,3.957,0,0,0-.678-.992,24.679,24.679,0,0,0,3.549-.732C61.246,25.02,71.223,34.856,76.49,37.868Z",
    transform: "translate(-2.031 -1.24)",
    fill: "#07a3c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10078",
    "data-name": "Path 10078",
    d: "M80.244,33.738a4.477,4.477,0,0,1-.693,3.332,2.634,2.634,0,0,1-2.864.741,5.353,5.353,0,0,1-1.26-.522s0,0-.008,0a.086.086,0,0,0-.026-.012h0c-5.161-2.814-16.455-14.412-16.567-14.527l-.17-.175-.229.08a22.992,22.992,0,0,1-4.343.877,1.967,1.967,0,0,0-.7-.171c-8.547-1.287-13.719-.387-13.935-.347a.4.4,0,0,0-.314.462.386.386,0,0,0,.449.323c.209-.036,5.273-.921,13.708.355l.044,0a1.1,1.1,0,0,1,.359.076.379.379,0,0,0,.236.112,3.007,3.007,0,0,1,1.264,1.853,3.384,3.384,0,0,1-.462,2.726s0,.008-.008.012-.012.016-.019.024l-.024.036a4.179,4.179,0,0,1-1.006.93.013.013,0,0,0-.008,0c-.78.211-8.5,2.172-23.177,2.172-7.823,0-9.5-5.707-9.57-5.95l-.027-.068c-.019-.04-1.96-4.273-3.247-20.458l18.074-.044a19.4,19.4,0,0,0,.425,8.637c-2.8.207-4.742.383-5.028.407a.4.4,0,0,0-.353.434.386.386,0,0,0,.418.359c.077-.008,2.279-.2,5.486-.434a.1.1,0,0,0,.035,0,.232.232,0,0,0,.054,0c8.148-.582,22.646-1.383,25.467.092C64.355,16.178,79.535,32.694,80.244,33.738Z",
    transform: "translate(0 0.117)",
    fill: "#07a3c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10079",
    "data-name": "Path 10079",
    d: "M50.833,42.4l-.849.848-.849-.848A5.733,5.733,0,0,0,41.028,50.5l.848.849,8.108,8.107,8.109-8.107.848-.849A5.733,5.733,0,1,0,50.833,42.4Z",
    transform: "translate(-1.015 -6.554)",
    fill: "#07a3c8"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrivacyPopUpLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/privacyPopUpLogo.1fb7f38b.svg";
export { ForwardRef as ReactComponent };